<div class="flex flex-col p-6 gap-5">
  <ep-breadcrumbs>
    <ep-breadcrumb [routerLink]="['/']"><span>Realm</span></ep-breadcrumb>
    <ep-breadcrumb [routerLink]="['/clients']"><span>Clients</span></ep-breadcrumb>
    <ep-breadcrumb><span>Request Client</span></ep-breadcrumb>
  </ep-breadcrumbs>

  <div class="flex items-center justify-between">
    <h1>Request a New Client</h1>
  </div>

  <section class="bg-surface-container rounded-lg p-6">
    @if (submissionSuccess()) {
      <ep-alert type="alert" color="success" variant="alt">
        <span slot="header">Request submitted!</span>
        <span slot="subtext">
          A realm admin will review your request. You can check its status under "My Requests".
        </span>
      </ep-alert>
      <div class="flex justify-end mt-6">
        <ep-button color="primary" [routerLink]="['/client-requests/mine']">
          View My Requests
        </ep-button>
      </div>
    } @else {
      <p class="text-surface-on-variant mb-6">
        Request a new client by providing a name. A realm admin will review and create it for you.
      </p>

      <form [formGroup]="form" class="flex flex-col gap-4">
        <ep-textfield
          label="Client Name"
          formControlName="name"
          placeholder="Enter a descriptive name"
          [required]="true"
          ngDefaultControl
        >
          @if (getFieldError('name')) {
            <div slot="error" id="name-error">{{ getFieldError('name') }}</div>
          }
        </ep-textfield>

        <ep-textfield
          label="Client ID"
          formControlName="clientId"
          placeholder="auto-generated-from-name"
          [required]="true"
          ngDefaultControl
          (input)="onClientIdInput()"
        >
          @if (getFieldError('clientId')) {
            <div slot="error" id="clientId-error">{{ getFieldError('clientId') }}</div>
          }
        </ep-textfield>
      </form>

      @if (submissionError()) {
        <ep-alert type="alert" color="danger" variant="alt" class="mt-4">
          <span slot="header">{{ submissionError() }}</span>
        </ep-alert>
      }

      <div class="flex justify-between mt-6">
        <ep-button [routerLink]="['/clients']" color="secondary"> Cancel </ep-button>
        <ep-button color="primary" [disabled]="form.invalid || isSubmitting()" (click)="submit()">
          @if (isSubmitting()) {
            Submitting...
          } @else {
            Submit Request
          }
        </ep-button>
      </div>
    }
  </section>
</div>
